import { FC, ReactNode, RefObject } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { ShowMoreOrLessStyled } from './ShowMoreOrLess.styles';

type Props = {
    children: ReactNode;
    titleRef?: RefObject<HTMLHeadingElement>;
    onExpanded?: () => void;
    minHeightToShowExpand?: number;
};

export const ShowMoreOrLess: FC<Props> = ({
    children,
    titleRef,
    onExpanded = () => undefined,
    minHeightToShowExpand,
}) => {
    const { t } = useTranslations();

    return (
        <ShowMoreOrLessStyled
            showMoreText={t['eshop.product_page.overview.show_more']}
            showLessText={t['eshop.product_page.overview.show_less']}
            data-test={ESHOP_TEST_ID.SHOW_MORE_OR_LESS}
            scrollBackToRef={titleRef}
            onExpanded={onExpanded}
            minHeightToShowExpand={minHeightToShowExpand}
        >
            {children}
        </ShowMoreOrLessStyled>
    );
};
